module.exports = __webpack_public_path__ + "img/sass-thumb-3.5535ca75.png";